import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Cart.css";
import { Link } from 'react-router-dom'; 
import { useNavigate } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "@fortawesome/fontawesome-free/css/all.css";
import { Typography } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelectedPoint } from "./SelectedPointContext";
import { useTranslation } from 'react-i18next';    
import axios from 'axios';
import '../../../i18n';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import tente from "../../assets/tente.webp"

import { useCart } from "../CartContext";

const CartPage = () => {
    const { cart, setCart, cartCount, setCartCount } = useCart();


  const { t, i18n } = useTranslation(); 

  const { setSelectedPointId } = useSelectedPoint();
  
  const { supprimerArticle, augmenterQuantite, diminuerQuantite, notify, emptyCart} = useOutletContext();
  const [pickupPoint, setPickupPoint] = useState({ sale_points: [] }); 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {  addToCart} = useOutletContext();


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BASE_URL+'/api/shop/sale-points', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.REACT_APP_API_KEY,

          },
        });
        if (!response.ok) {
          if (response.status === 500) {
            // Redirection vers la page 500
            navigate("/500");
          }
          throw new Error(`Erreur HTTP : ${response.status}`);
        }


        const data = await response.json();
        setPickupPoint(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchCategories();
  }, []);

  const [selectedPoint, setSelectedPoint] = useState(null); 


  const handleRedirect = () => {
      navigate("/tickets"); // Redirige vers la page Tickets
  };  
  const suprimerArticle = (id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };  

  const getBadgeClass = (id) => {
    const originalItem = cart.find((cartItem) => cartItem.id === id);
    if (!originalItem) return "bg-secondary"; // Classe par défaut si non trouvé
  
    switch (originalItem.type) {
      case "ticket":
        return "bg-success";
      case "product":
        return "bg-danger";
      default:
        return "bg-warning";
    }
  };

   // Vérifie si le panier contient des tickets
   const hasTickets = cart.some((item) => item.type === "ticket");
   const hasProducts = cart.some((item) => item.type === "product");

   // Vérifie si le panier contient des tentes
   const hasTents = cart.some((item) => item.type === "tent");


   const [open, setOpen] = useState(false);

   const handleClickOpen = () => {
     setOpen(true);
   };
 
   const handleClose = () => {
     setOpen(false);
   };
  //  const handleProceedPayment = () => {

    
  //   if (!selectedPoint && hasProducts) {
  //     // Affiche une alerte ou utilise un dialogue pour indiquer que le point de retrait n'est pas sélectionné
  //     handleClickOpen();
  //     return;  // Empêche la redirection vers la page d'achat
  //   }
  //   // Si un point de retrait est sélectionné, redirige l'utilisateur vers la page d'achat
  //   navigate('/achat');
  // };



  /////////////////////////////////////////////////////////////////////////////////////////////////

  const lang = localStorage.getItem('language') || "FR";
  let newlang = ""; // Utilisez let au lieu de const
  
  if (lang === "FRA" || lang === "FR" || lang === "") {
      newlang = 'FR';
  } else if (lang === "ENG") {
      newlang = 'EN';
  } else if (lang === "ESP") {
      newlang = 'ES';
  } else if (lang === "POT") {
      newlang = 'PT';
  }
  
  const translateText = async (text, targetLanguage) => {
      if (targetLanguage === 'FR') {
          return text; // Si la langue cible est déjà le français, ne traduisez pas.
      }
      const apiKey = process.env.REACT_APP_DEEPL_API_KEY;
      const url = process.env.REACT_APP_DEEPL_URL;
      const params = new URLSearchParams();
      params.append("auth_key", apiKey);
      params.append("text", text);
      params.append("target_lang", targetLanguage);
  
      try {
          const response = await fetch(url, {
              method: "POST",
              headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
              },
              body: params,
          });
          if (!response.ok) {
            if (response.status === 500) {
              // Redirection vers la page 500
              navigate("/500");
            }
            throw new Error(`Erreur HTTP : ${response.status}`);
          }
  
          const data = await response.json();
          if (data.translations && data.translations[0] && data.translations[0].text) {
              return data.translations[0].text;
          } else {
              return text; // Retournez le texte original si la traduction échoue
          }
      } catch (error) {
          return text; // Retournez le texte original en cas d'erreur
      }
  };
  
  const [translatedCart, setTranslatedCart] = useState([]);
  const [translatedPickupPoints, setTranslatedPickupPoints] = useState([]);
  
  const translateItems = async (items, type) => {
      return await Promise.all(
          items.map(async (item) => {
              const translatedName = await translateText(item.name, newlang);
              const translatedType = await translateText(item.type, newlang);
              const translatedAddress = type === "pickup" ? await translateText(item.address, newlang) : null;
              return type === "pickup" 
                  ? { ...item, name: translatedName, type: translatedType, address: translatedAddress }
                  : { ...item, name: translatedName, type: translatedType };
          })
      );
  };
  
  useEffect(() => {
      if (cart.length > 0) {
          translateItems(cart, "cart").then(setTranslatedCart);
      }
  }, [cart, lang]);
  
  useEffect(() => {
      if (pickupPoint && pickupPoint.sale_points?.length > 0) {
          translateItems(pickupPoint.sale_points, "pickup").then(setTranslatedPickupPoints);
      }
  }, [pickupPoint, lang]);
  
  const [translatedAddress, setTranslatedAddress] = useState(null);
  
  const translateAddress = async (address, targetLanguage) => {
      try {
          const translated = await translateText(address, targetLanguage);
          setTranslatedAddress(translated);
      } catch (error) {
          setTranslatedAddress(address);
      }
  };
  
  useEffect(() => {
      if (selectedPoint) {
          translateAddress(selectedPoint.address, newlang);
      }
  }, [newlang, selectedPoint]);
  

const [isVerifying, setIsVerifying] = useState(false);

const [dialogOpen, setDialogOpen] = useState(false);
const [dialogMessage, setDialogMessage] = useState("");
const [dialogTitle, setDialogTitle] = useState("");



const CustomDialog = ({ open, onClose, message, title }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
    <div dangerouslySetInnerHTML={{ __html: message }} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} autoFocus>Fermer</Button>
    </DialogActions>
  </Dialog>
);

const handleSelectPoint = async (point) => {
  setSelectedPointId(point?.id || null);
  translateAddress(point?.address, newlang); // Traduisez l'adresse si nécessaire

  // Préparez les IDs pour la requête
  const productIds = cart
    .filter((item) => item.type === "product")
    .map((item) => item.id.split("-")[1]);
  const ticketIds = cart
    .filter((item) => item.type === "ticket")
    .map((item) => item.id.split("-")[1]);

  // Construisez dynamiquement les paramètres de la requête
  const queryParams = [];
  if (point && point.id && (productIds.length > 0 || ticketIds.length > 0)) {
    queryParams.push(`sale_point_id=${point.id}`);
  }
  if (productIds.length > 0) {
    queryParams.push(`products=${productIds.join(",")}`);
  }
  if (ticketIds.length > 0) {
    queryParams.push(`tickets=${ticketIds.join(",")}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  // Déterminez l'URL
  const url = `${process.env.REACT_APP_BASE_URL}/api/shop/inventory${queryString}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": process.env.REACT_APP_API_KEY,
      },
    });

    // if (!response.ok) {
    //   throw new Error("Erreur lors de la récupération des données");
    // }
    if (!response.ok) {
      if (response.status === 500) {
        // Redirection vers la page 500
        navigate("/500");
      }
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    const data = await response.json();

    // Vérifiez les produits
    const unavailableProducts = [];
    if (productIds.length > 0) {
      data.data.products.forEach((product) => {
        const cartItem = cart.find(
          (item) =>
            item.type === "product" && item.id.split("-")[1] === String(product.id)
        );
        if (cartItem && cartItem.quantity > product.available_quantity) {
          unavailableProducts.push(product.name); // Ajoutez seulement le nom du ticket

        }
      });
    }

    // Vérifiez les tickets
// Vérifiez les tickets
const unavailableTickets = [];
if (ticketIds.length > 0) {
  data.data.tickets.forEach((ticket) => {
    const cartItem = cart.find(
      (item) =>
        item.type === "ticket" && item.id.split("-")[1] === String(ticket.id)
    );
    if (cartItem && cartItem.quantity > ticket.available_quantity) {
      unavailableTickets.push(ticket.name); // Ajoutez seulement le nom du ticket
    }
  });
}

// Si des produits ou des tickets sont indisponibles
if (unavailableProducts.length > 0 || unavailableTickets.length > 0) {
  let unavailableItemsMessage = "";

  // Ajoutez le message pour les produits indisponibles
  if (unavailableProducts.length > 0) {
    unavailableItemsMessage += `${t("unavailable_items_message")}\n\n<br/>${unavailableProducts.join(
      " <br/>"
    )}\n`;
    setDialogOpen(true);
    setDialogMessage(unavailableItemsMessage.trim()); // Montrez les messages simplifiés
    setDialogTitle(t("unavailable_items_pr_title"));
    setSelectedPoint(null); // Réinitialisez uniquement si des produits sont indisponibles
    setSelectedPointId(null);
  }

  // Ajoutez le message pour les tickets indisponibles
  if (unavailableTickets.length > 0) {
    unavailableItemsMessage += `${t("unavailable_items_messagetick")}\n\n<br/>${unavailableTickets.join(
      "<br/>"
    )}`;
      // Affichage dans une fenêtre modale
    setDialogOpen(true);
    setDialogMessage(unavailableItemsMessage.trim()); // Montrez les messages simplifiés
    setDialogTitle(t("unavailable_items_tick_title"));
  }


    }  else {
      // Si tout est disponible
      setSelectedPoint(point);
      setSelectedPointId(point?.id || null);
      setIsDrawerOpen(false);
    }
  } catch (error) {
    setSelectedPoint(null); // Réinitialisez en cas d'erreur
    setSelectedPointId(null);
  } finally {
    setIsVerifying(false); // Fin des vérifications
  }
};
const [isDialogOpen, setIsDialogOpen] = useState(false);

const handleOpenDialog = () => {
  setIsDialogOpen(true); // Ouvrir le dialogue
};

const handleCloseDialog = () => {
  setIsDialogOpen(false); // Fermer le dialogue
};






const handleSelectProducts = async (point) => {
  const hasProductsOrTickets = cart.some(
    (item) => item.type === "product"
  );

  // Si le panier contient des produits ou des tickets, vérifiez si un point de retrait est sélectionné
  if (hasProductsOrTickets && (!point || !point.id)) {
    handleClickOpen();
    return; // Arrêtez la fonction ici si aucun point n'est sélectionné
  }


  setSelectedPointId(point?.id || null);
  translateAddress(point?.address, newlang); // Traduisez l'adresse si nécessaire

  // Préparez les IDs pour la requête
  const productIds = cart
    .filter((item) => item.type === "product")
    .map((item) => item.id.split("-")[1]);
  const ticketIds = cart
    .filter((item) => item.type === "ticket")
    .map((item) => item.id.split("-")[1]);

  // Construisez dynamiquement les paramètres de la requête
  const queryParams = [];
  if (point && point.id && (productIds.length > 0 || ticketIds.length > 0)) {
    queryParams.push(`sale_point_id=${point.id}`);
  }
  if (productIds.length > 0) {
    queryParams.push(`products=${productIds.join(",")}`);
  }
  if (ticketIds.length > 0) {
    queryParams.push(`tickets=${ticketIds.join(",")}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  // Déterminez l'URL
  const url = `${process.env.REACT_APP_BASE_URL}/api/shop/inventory${queryString}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": process.env.REACT_APP_API_KEY,
      },
    });

    if (!response.ok) {
      if (response.status === 500) {
        navigate("/500");
      }
      throw new Error(`Erreur HTTP : ${response.status}`);
    }
    const data = await response.json();
// Vérifiez les produits
const unavailableProducts = [];
if (productIds.length > 0) {
  data.data.products.forEach((product) => {
    const cartItem = cart.find(
      (item) =>
        item.type === "product" && item.id.split("-")[1] === String(product.id)
    );
    if (cartItem && cartItem.quantity > product.available_quantity) {
      unavailableProducts.push(product.name); // Ajoutez seulement le nom du produit
    }
  });
}

// Vérifiez les tickets
const unavailableTickets = [];
if (ticketIds.length > 0) {
  data.data.tickets.forEach((ticket) => {
    const cartItem = cart.find(
      (item) =>
        item.type === "ticket" && item.id.split("-")[1] === String(ticket.id)
    );
    if (cartItem && cartItem.quantity > ticket.available_quantity) {
      unavailableTickets.push(ticket.name); // Ajoutez seulement le nom du ticket
    }
  });
}

// Vérifiez les tentes
const totalTentsInCart = cart
  .filter((item) => item.type === "tent")
  .reduce((total, item) => total + item.quantity, 0);

let unavailableItemsMessage = "";

  // Construisez le message pour les produits indisponibles
  if (unavailableProducts.length > 0) {
    unavailableItemsMessage += `${t("unavailable_items_message")}\n\n<br/>${unavailableProducts.join(
      "<br/>"
    )}\n`;
        setDialogOpen(true);
      setDialogMessage(unavailableItemsMessage.trim()); // Montrez les messages simplifiés
      setDialogTitle(t("unavailable_items_pr_title"));
    setSelectedPoint(null); // Réinitialisez uniquement si des produits sont indisponibles
    setSelectedPointId(null);
  }

  // Construisez le message pour les tickets indisponibles
  if (unavailableTickets.length > 0) {
    unavailableItemsMessage += `${t("unavailable_items_messagetick")}\n\n<br/>${unavailableTickets.join(
      "<br/>"
    )}\n`;
    setDialogOpen(true);
    setDialogMessage(unavailableItemsMessage.trim()); // Montrez les messages simplifiés
    setDialogTitle(t("unavailable_items_tick_title"));
  }

  // Construisez le message pour les tentes indisponibles
  if (totalTentsInCart > data.data.tent_quantity) {
    unavailableItemsMessage += `${t("unavailable_items_messagetent")}\n`;
    setDialogOpen(true);
    setDialogMessage(unavailableItemsMessage.trim()); // Montrez les messages simplifiés
    setDialogTitle(t("unavailable_items_tent_title"));
  }

  // Si des éléments sont indisponibles, affichez une fenêtre modale
  if (!unavailableItemsMessage.trim()) {

        // Si tout est disponible
        setSelectedPoint(point);
        setSelectedPointId(point?.id || null);
        setIsDrawerOpen(false);
        navigate('/achat');
      }
  } catch (error) {
    setSelectedPoint(null); // Réinitialisez en cas d'erreur
    setSelectedPointId(null);
  } finally {
    setIsVerifying(false); // Fin des vérifications
  }
};







const viderPanier = async () => {
  // Videz le panier dans le localStorage
  localStorage.setItem("cart", JSON.stringify([]));
  localStorage.setItem("cartCount", "0");

  emptyCart();

  // // Réinitialisez les états locaux
  setCart([]);
  setCartCount(0);

  // // Réinitialisez `translatedCart`
  setTranslatedCart([]);

  // // Émettez un événement personnalisé
  const event = new CustomEvent("cartUpdated", { detail: { cart: [], cartCount: 0 } });
  window.dispatchEvent(event);

};


useEffect(() => {
  const handleCartUpdate = (event) => {
    const { cart, cartCount } = event.detail;
    setCart(cart);
    setCartCount(cartCount);
  };

  // Écoute de l'événement
  window.addEventListener("cartUpdated", handleCartUpdate);

  // Nettoyer l'écouteur à la désinstallation du composant
  return () => {
    window.removeEventListener("cartUpdated", handleCartUpdate);
  };
}, []);
const typeTranslations = {
  product: "produit",
  tent: "tente",
  ticket: "ticket",
};
  
const language = localStorage.getItem('language') || "FRA";

  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">{t("cart_title")}</h1>

      <div className="row gx-4">
        {/* Colonne principale : Liste des articles */}
        <div className="col-lg-8 col-md-12 mb-4">
          <div className="card shadow-sm p-3">
            <table className="table align-middle">
              <thead className="text-muted">
                <tr>
                  <th>{t("product")}</th>
                  <th>{t("type")}</th>
                  <th>{t("price")}</th>
                  <th>{t("quantity")}</th>
                  <th>{t("total")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              {translatedCart.length > 0 && cart.length > 0 && (
                translatedCart.map((item) => (
                  
                  <tr key={item.id}>
                    <td className="d-flex align-items-center">
                      {/* Si le type est "tent", on affiche une image spécifique */}
                      {item.type === "tent" || item.type === "tenda"  || item.type === "tienda" ? (
                        <img
                          src= {tente} // Remplacez par le chemin réel de votre image
                          alt="Tent"
                          className="rounded me-2"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/${item.img}`}
                          alt={item.name}
                          className="rounded me-2"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      <span className="namecart">{item.name}</span>
                    </td>
                    <td>
                    <span className={`badge ${getBadgeClass(item.id)}`}>
                      {/* Affiche la traduction en français si la langue est "fr" */}
                      {language === "FRA" ? typeTranslations[item.type] || item.type : item.type}
                    </span>
                    </td>
                    {/* <td>
                      <span className="badge bg-success">{item.type}</span>
                    </td> */}
                    <td> {Number(item.price).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => { if (item.quantity > 1) {
                            diminuerQuantite(item.id);
                          } }}
                        >
                          -
                        </button>
                        <span className="mx-2">{item.quantity}</span>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {   if (item.quantity < 10) {
                            augmenterQuantite(item.id);
                          }}}
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td>{(item.price * item.quantity).toLocaleString()} FCFA</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          if (translatedCart.length === 1) {
                            viderPanier(); // Appelle la fonction pour vider le panier s'il ne reste qu'un seul élément
                          } else {
                            supprimerArticle(item.id);
                            suprimerArticle(item.id);
                          }
                        }}
                      >
                        x
                      </button>

                    </td>
                  </tr>
                ))
              )}
              </tbody>
            </table>
            {/* Paragraphe total en bas à droite */}
            <div className="text-end mt-3 me-2" style={{ paddingRight: "15px" }}>
              <p className="fw-bold fs-5 text-danger">
                {cart
                  .reduce((acc, item) => acc + item.price * item.quantity, 0)
                  .toLocaleString()}{" "}
                FCFA
              </p>
            </div>

        </div>
        {/* Bouton pour vider le panier */}
    <div className="text-end">
      <button
        className="btn btn-danger btn-sm mt-3"
        onClick={viderPanier}
      >
        {t("clear_cart")}
      </button>
    </div>


        </div>


        {/* Colonne secondaire : Total panier */}
        <div className="cartcontainer" >
            <h2 style={styles.title}>{t("total_cart")}</h2>
            <hr className="cool"></hr>

            <div style={styles.section}>
            {hasProducts && (
        <>

        <h3 style={styles.sectionTitle}>{t("all")}</h3>
        <hr className="cool"></hr>
        <div style={styles.pickupPoint}>
        <button onClick={toggleDrawer(true)} style={styles.pickupButton}>
          {selectedPoint ? t("modpickup_point_button") : t("pickup_point_button")}
        </button>


      {/* Drawer */}
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
      <div className="drawer-container">
        <div className="drawer-header">
          <h2> {t("pickup_point_not_selected")}</h2>
          <IconButton className="close-button" onClick={toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="divider"></div>

        {loading ? (
          <p> {t("chargement")}</p>
        ) : error ? (
          <p>{t("ereur")} {error}</p>
        ) : (
          <List>
            {translatedPickupPoints.map((point) => (
              <ListItem className="list-item" key={point.id}>
                <div>
                  <ListItemText 
                    primary={<span className="list-item-text-primary">{point.name}</span>}
                    secondary={<span className="list-item-text-secondary">{point.address}</span>} 
                  />
                  <ListItemText 
                    primary={<span className="list-item-text-primarys">{t("Heures_ouverture")} :</span>} 
                    secondary={<span className="list-item-text-secondary">{point.opening_period}</span>} 
                  />
                  <CustomDialog
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)} // Ferme le dialogue
                    message={dialogMessage}
                    title={dialogTitle}
                  />
                </div>
                <button
                  className="select-button"
                  onClick={() => {
                    handleSelectPoint(point);// Ensuite handleSelectPoint avec les arguments nécessaires
                  }}
                >
                  {t("select")}
                </button>
              </ListItem>
            ))}
          </List>
        )}
      </div>
    </Drawer>

{!isVerifying && selectedPoint && (
    <div className="selected-point-container">
      <p className="soo"><strong>{selectedPoint.name}</strong></p>
      <p>{t("adresse")} {translatedAddress || selectedPoint.address}</p> {/* Affiche l'adresse traduite ou originale */}
      {/* <p>{t("email")} : {selectedPoint.email}</p> */}
      <p>{t("Heures_ouverture")} : {selectedPoint.opening_period}</p>
    </div>
  )}
                </div>
 </>
)}
                {hasTickets && (
        <>
                <br/>
                <br/>
                <hr className="cool"></hr>

                <h3 style={styles.sectionTitle}>{t("allt")}</h3>
                <hr className="cool"></hr>
                <p style={styles.text}>
                
                {t("tickets_info")}
                </p>
                <hr className="cool"></hr>
                </>
                )}
                 {hasTents && (
               <>
                <h3 style={styles.sectionTitle}> {t("allte")}</h3>
                <hr className="cool"></hr>
                <p style={styles.text}>

                {t("tents_info")}
                </p>
                <hr className="cool"></hr>
                </>
                 )}

                <div className="tot-container">
                    {/* <div className="total-label">Total:</div> */}
                    <div className="total-value">
                        <p className="fw-bold fs-5 text-danger">{t("total")}    
                        {cart
                            .reduce((acc, item) => acc + item.price * item.quantity, 0)
                            .toLocaleString()}{" "}
                        FCFA
                        </p>
                    </div>
                    </div>
                    <button
                  className={`view-cart-btn ${!selectedPoint ? 'disabled' : ''}`}
                  onClick={() => {
                    handleSelectProducts(selectedPoint);
                    
                  }}
                  disabled={cart.length === 0 || cartCount === 0}
                >
                  {t("proceed_payment")}
                </button>
                    {/* Dialogue */}
              <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle> {t("attention")}</DialogTitle>
                <DialogContent>
                  <p>
                  {t("mess_attention")}
                  
                  </p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDialog} color="primary" variant="contained">
                  {t("OK")}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Point de retrait non sélectionné"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                  {t("dialog_description")}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                  {t("dialog_ok")}
                  </Button>
                </DialogActions>
              </Dialog>
                  </div>
              </div>
    <div className="button-container">
  <button className="payment-button" onClick={handleRedirect} >
  
  {t("continue_shopping")}

  </button>
    </div>
</div>

    </div>
  );
};


const styles = {
    pickupButton: {
        backgroundColor: "#c62828",
        color: "white",
        fontWeight: "bold",
        width: "100%",
        border: "1px solid #a88734",
        borderRadius: "4px",
        padding: "10px 20px",
        fontSize: "16px",
        cursor: "pointer",
      },
      icon: {
        marginRight: "8px",
      },

    title: {
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "20px",
    },
    section: {
      marginBottom: "20px",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "5px",
    },
    text: {
      fontSize: "14px",
      color: "#555",
    },
    pickupPoint: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "10px",
    },

    icon: {
      fontSize: "16px",
    },
  };

export default CartPage;
